import React, { useContext, useState } from "react";

import PageHeader from "../../../components/PageHeader";
import { ModalContext } from "../../../components/ModalProvider";
import { ALL_USER_GROUPS_QUERY } from "../../../graphql/UserGroups/UserGroups.graphql";
import {
  AddUserGroupForm,
  EditUserGroupForm
} from "../../../components/UserGroups";

import { USER_GROUP_COLUMNS } from "./columns";
import DataTable from "../../../components/DataTable";

import { getFilterState, saveFilterState } from "../../../utils";

import GroupFilters from "./GroupFilters";

const GroupsPage = () => {
  const INITIAL_FILTER_STATE = getFilterState("USER_GROUP_FILTERS", {
    // Active: true
  });
  const { setModalOpen } = useContext(ModalContext);
  const [filters, setFilters] = useState(INITIAL_FILTER_STATE);
  const handleSetFilters = inputs => {
    saveFilterState("USER_GROUP_FILTERS", inputs);
    setFilters({ ...inputs });
  };
  const resetFilters = () => handleSetFilters({ Active: true });

  return (
    <React.Fragment>
      <PageHeader
        FilterComponent={GroupFilters}
        columns={USER_GROUP_COLUMNS}
        filters={filters}
        name="UserGroups"
        query={ALL_USER_GROUPS_QUERY}
        resetFilters={resetFilters}
        setFilters={handleSetFilters}
        title="Groups"
        onAddClick={() =>
          setModalOpen(true, <AddUserGroupForm setModalOpen={setModalOpen} />)
        }
      />
      <DataTable
        columns={USER_GROUP_COLUMNS}
        dataQuery={ALL_USER_GROUPS_QUERY}
        initialSortBy={[{ id: "Name", desc: false }]}
        name="UserGroup"
        where={filters}
        onRowClick={data =>
          setModalOpen(
            true,
            <EditUserGroupForm
              group={data}
              setModalOpen={() => setModalOpen(false, "")}
            />
          )
        }
      />
    </React.Fragment>
  );
};

export default GroupsPage;
